import { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

import styles from './WidgetTourLauncher.module.scss'

export const WidgetTourLauncher = ({ children }: PropsWithChildren) => {
  if (typeof document === 'undefined') {
    return null
  }

  return createPortal(<div className={styles.root}>{children}</div>, document.body)
}
